import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { FOUR_WEEK_FORECAST_REPORT_ENDPOINT } from '../endpoint';
import { FourWeekForecastReportRequestModel } from '../models/FourWeekForecastReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: FourWeekForecastReportRequestModel): Promise<void> => {
    return await axios
      .get(`${FOUR_WEEK_FORECAST_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'cash-register-report',
        });
      });
  };
